import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/ciudad`

const listar = async (IdEstado: string | number, texto: string): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/`,
        metodo: "GET",
        params:{
            IdEstado,
            texto
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const CiudadService = {
    listar,
};

export default CiudadService;